export const UBE_MODULE_COMPROMISED_PASSWORD = 'Compromised Password';
